/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `APPROVED` - APPROVED
 *   * `REJECTED` - REJECTED
 * ```
 */
export const EpsiOrderApproveStateEnum = { APPROVED: 'APPROVED', REJECTED: 'REJECTED' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type EpsiOrderApproveStateEnum = ValuesOf<typeof EpsiOrderApproveStateEnum>;

export type EpsiOrderApproveStateEnumRequest = EpsiOrderApproveStateEnum;
export type EpsiOrderApproveStateEnumResponse = EpsiOrderApproveStateEnum;
